module.exports = __webpack_public_path__ + "images/quotas/export.svg";